import { useRef } from 'react'

export const usePaginationTracking = (
  currentPage: number,
  pageSize: number,
  filterValue?: string | number
) => {
  const prevPageRef = useRef(currentPage)
  const prevPageSizeRef = useRef(pageSize)
  const prevFilterRef = useRef(filterValue)

  const pageChanged = prevPageRef.current !== currentPage
  const pageSizeChanged = prevPageSizeRef.current !== pageSize
  const filterChanged =
    filterValue !== undefined && prevFilterRef.current !== filterValue

  const updateRefs = () => {
    prevPageRef.current = currentPage
    prevPageSizeRef.current = pageSize
    if (filterValue !== undefined) {
      prevFilterRef.current = filterValue
    }
  }

  return {
    pageChanged,
    pageSizeChanged,
    filterChanged,
    updateRefs,
  }
}
